import * as placeMenuAPI from "../api/place-menu-api";
import {
  IPlaceCategory,
  IPlaceProduct,
  IPlaceProductCard,
} from "@/modules/place-module";
import { LocationQueryValue } from "vue-router";

import { defineStore } from "pinia";
import { IPaginationResponse } from "@/package/global-types";

export const usePlaceMenuStore = defineStore("place-menu-store", {
  state: () => ({
    menuLoadingStatus: "loading" as "loading" | "loaded",
    categories: null as null | Array<IPlaceCategory>,
    selectedCategory: null as null | number,
    products: [] as Array<IPlaceProductCard>,
    orderAllowed: false,
    pagination: null as null | IPaginationResponse,
    product: null as null | IPlaceProduct,
  }),

  actions: {
    async loadPlaceProducts(
      placeId: LocationQueryValue | LocationQueryValue[],
      categoryId: number,
      page: number
    ) {
      if (page === 1) {
        this.menuLoadingStatus = "loading";
      }
      try {
        const resp = await placeMenuAPI.apiGetPlaceProducts(
          placeId,
          categoryId,
          page
        );
        if (page === 1) {
          this.products = resp.data.data.products;
        } else {
          this.products = this.products?.concat(resp.data.data.products);
        }
        this.categories = resp.data.data.categories;
        this.pagination = resp.data.data.pagination;
        this.orderAllowed = resp.data.data.order_allowed;
      } finally {
        this.menuLoadingStatus = "loaded";
      }
    },

    selectMenuCategory(category: number) {
      if (this.selectedCategory === category) {
        this.selectedCategory = null;
        return;
      }

      this.selectedCategory = category;
    },

    async getPlaceProduct(
      productId: LocationQueryValue | LocationQueryValue[]
    ) {
      this.clearPlaceProduct();
      const resp = await placeMenuAPI.apiGetPlaceProductInfo(productId);
      this.product = resp.data.data;
    },

    clearPlaceMenu() {
      this.menuLoadingStatus = "loading";
      this.categories = null;
      this.products = [];
      this.orderAllowed = false;
      this.pagination = null;
      this.product = null;
    },

    clearPlaceProduct() {
      this.product = null;
    },
  },
});
